
<div *ngIf="!['delete_object', 'import_object'].includes(action)">
    <div style="padding: 15px; margin: auto;  max-width: 800px;">
        <div class="class-mat-field-left" >
            <h2  *ngIf="['add_new', 'ai_parse_metadata', 'object_scrapping'].includes(action)">Add new {{manageKeyValue?.[manageKey]?.element ?? 'Element'}}</h2>
            <div class="container" >
                <div fxLayout="row">
                    <div class="label-style" fxFlex="20%">Action</div>
                    <div fxFlex="80%">
                        <mat-select placeholder="Action" [formControl]="actionControl" (selectionChange)="updateDetails()">
                            <mat-option *ngIf="data != null" [value]="'add_new'" >Add New</mat-option>
                            <mat-option [value]="'object_scrapping'" *ngIf="data != null &&  manageKey == 'vca_structure'">Web Scrapping Metadata</mat-option>
                            <mat-option *ngIf="data != null && manageKey == 'vca_module'" [value]="'ai_parse_metadata'" >AI Generate Modules</mat-option>
                            <mat-option *ngIf="data == null" [value]="'update'" >Update</mat-option>
                            <mat-option [value]="'merge_with'" *ngIf="data == null && this.rowInfos['id'] > 0">Merge together With</mat-option>
                            
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="['update','add_new', 'ai_parse_metadata', 'object_scrapping'].includes(action)" fxLayout="row" style="margin-top: 15px;">
                    <div class="label-style" fxFlex="20%">{{manageKeyValue?.[manageKey]?.parent ?? 'Parent'}}</div>
                    <div fxFlex="80%">
                        <mat-select  *ngIf="manageKey == 'vca_module'" placeholder="{{manageKeyValue?.[manageKey]?.parent ?? 'Parent'}}" [formControl]="parentControl" class="multiselect" multiple>
                            <input class="col-input-filter" [formControl]="searchParentControl">
                            <mat-option [value]="element['id']" *ngFor="let element of filteredParent; let i = index">
                                <span class="mat-option-content">{{element['name']}}: {{element['full_name']}}</span>
                                <span class="mat-option-checkbox">
                                    <mat-icon *ngIf="selectedElement(parentControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                                </span>
                            </mat-option>
                        </mat-select>
                        <mat-select  *ngIf="manageKey != 'vca_module'" placeholder="{{manageKeyValue?.[manageKey]?.parent ?? 'Element'}}" (selectionChange)="setScrappingCode()" [formControl]="parentControl">
                            <input class="col-input-filter" [formControl]="searchParentControl">
                            <mat-option [value]="element['id']" *ngFor="let element of filteredParent; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="['update','add_new'].includes(action)" style="margin-top: 15px;">
                    <div *ngIf="manageKey == 'vca_department'" fxLayout="row" style="margin-bottom: 15px;">
                        <div class="label-style" fxFlex="20%">Cycle</div>
                        <div fxFlex="80%">
                            <mat-select placeholder="Cycle" [formControl]="cycleControl"> 
                                <mat-option [value]="element['id']" *ngFor="let element of cycles; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div *ngIf="manageKey == 'vca_module'" fxLayout="row" style="margin-bottom: 15px;">
                        <div class="label-style" fxFlex="20%">Semester</div>
                        <div fxFlex="80%">
                            <mat-select placeholder="Semester" [formControl]="semesterControl">
                                <mat-option [value]="element['id']" *ngFor="let element of semesters; let i = index">{{element['full_name']}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div fxLayout="row">
                        <div class="label-style" fxFlex="20%">Name</div>
                        <div fxFlex="80%">
                            <input class="col-input" [formControl]="nameControl" placeholder="Name" style="margin: 0;">
                        </div>
                    </div>
                    <div class="separator"></div>
                    <div fxLayout="row">
                        <div class="label-style" fxFlex="20%">Full Name</div>
                        <div fxFlex="80%">
                            <input class="col-input" [formControl]="fullNameControl" placeholder="Full Name" style="margin: 0;">
                        </div>
                    </div>
                    <div fxLayout="row" style="margin-top: 15px;">
                        <div class="label-style" fxFlex="20%">Type</div>
                        <div fxFlex="80%">
                            <mat-select *ngIf="manageKey == 'vca_institution'" placeholder="Type" [formControl]="typeControl">
                                <mat-option [value]="element" *ngFor="let element of institutionTypes; let i = index">{{element}}</mat-option>
                            </mat-select>
                            <mat-select *ngIf="manageKey == 'vca_structure'" placeholder="Type" [formControl]="typeControl">
                                <mat-option [value]="element" *ngFor="let element of structureTypes; let i = index">{{element}}</mat-option>
                            </mat-select>
                            <mat-select *ngIf="manageKey == 'vca_department'" placeholder="Type" [formControl]="typeControl">
                                <mat-option [value]="element['key']" *ngFor="let element of departmentTypes; let i = index">{{element['value']}}</mat-option>
                            </mat-select>
                            <mat-select *ngIf="manageKey == 'vca_module'" placeholder="Type" [formControl]="typeControl">
                                <mat-option [value]="element" *ngFor="let element of moduleTypes; let i = index">{{element}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div *ngIf="manageKey == 'vca_module'" fxLayout="row" style="margin-top: 15px;">
                        <div class="label-style" fxFlex="20%">Credits</div>
                        <div fxFlex="80%">
                            <mat-select placeholder="Credits" [formControl]="creditControl">
                                <mat-option *ngFor="let credit of credits" [value]="credit"> {{ credit }} {{ credit === 1 ? 'credit' : 'credits' }}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                    <div *ngIf="manageKey == 'vca_module'" fxLayout="row" style="margin-top: 15px;">
                        <div class="label-style" fxFlex="20%">Category</div>
                        <div fxFlex="80%">
                            <mat-select placeholder="Category" [formControl]="moduleCategoryControl">
                                <mat-option [value]="element['id']" *ngFor="let element of categories; let i = index">{{element['name']}}: {{element['full_name']}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
                <div *ngIf="action == 'merge_with'" fxLayout="row" style="margin-top: 15px;">
                    <div class="label-style" fxFlex="20%">Merge with</div>
                    <div fxFlex="80%">
                        <mat-select placeholder="{{manageKeyValue?.[manageKey]?.element ?? 'Element'}}" [formControl]="mergeWithControl" class="multiselect" multiple>
                            <input class="col-input-filter" [formControl]="searchMergeWithControl">
                            <mat-option [value]="element['id']" *ngFor="let element of filteredMergeWith; let i = index">
                                <span class="mat-option-content">{{element['id']}}- {{element['name']}}: {{element['full_name']}}</span>
                                <span class="mat-option-checkbox">
                                    <mat-icon *ngIf="selectedElement(mergeWithControl, element)" class="mat-icon material-icons check-icon" fontIcon="done"></mat-icon>
                                </span>
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <div *ngIf="action == 'ai_parse_metadata'"style="margin-top: 15px;">
                    <div fxLayout="row">
                        <div class="label-style" fxFlex="20%">Prompt</div>
                        <div fxFlex="80%">
                            <textarea class="col-input" rows="6" style="margin: 1px; resize: none;" maxlength="2000" placeholder="Create your prompt..." [formControl]="aiGereratorPromptControl"></textarea>
                        </div>
                    </div>
                    <div fxLayout="row" style="margin-top: 15px;">
                        <div class="label-style" fxFlex="20%">Document</div>
                        <div fxFlex="80%">
                            <input class="col-input file_erea" type="file" accept=".svg, .png, .jpg, .jpeg, .webp, .pdf" (change)="onFileSelected($event)">
                        </div>
                    </div>
                </div>
                <div *ngIf="action == 'object_scrapping'" style="margin-top: 15px;">
                    <ngx-monaco-editor style="height:400px;display:block" [formControl]="pythonCodeControl" [options]="{language: 'python', theme: 'vs-dark', automaticLayout: true}"></ngx-monaco-editor>
                    
                </div>
                <div fxLayout="row" style="margin-top: 15px;">
                    <div fxFlex="100%" style="float: right;">
                        <button *ngIf="manageKey == 'vca_structure'" type="button" class="button-secondary-small left-side" (click)="runSaveScrappingData('save')">Save</button>
                        <button *ngIf="manageKey == 'vca_structure'" class="button-validate-small" (click) = "runSaveScrappingData('run')">Run</button>
                        <button *ngIf="manageKey != 'vca_structure'" class="button-validate-small" (click) = "verifyAndUpload()">Apply</button>
                    </div>
                </div>
                <div *ngIf="action == 'object_scrapping'" style="margin-top:15px;">
                    <div style="display:flex;gap:15px;padding:5px 10px;background:#f5f5f5;border-bottom:1px solid #ddd;">
                        <span style="cursor:pointer" [style.font-weight]="scrappingResultSwitch == 'data' ? 'bold' : 'normal'" (click)="scrappingResultSwitch='data'">Data</span>
                        <span style="cursor:pointer" [style.font-weight]="scrappingResultSwitch == 'terminal' ? 'bold' : 'normal'" (click)="scrappingResultSwitch='terminal'">Terminal</span>
                    </div>
                    <div *ngIf="scrappingResultSwitch == 'data'" style="height:180px;overflow:auto;border:1px solid #ddd;">
                        <div fxLayout="row" style="padding: 5px;">
                            <div class="label-style" fxFlex="60%">Total: {{scrappingData.length}}</div>
                            <div fxFlex="40%">
                                <button type="button" class="button-secondary-small left-side" (click)="verifyAndUpload()">Upload scraped Data</button>
                            </div>
                        </div>
                        <table *ngIf="scrappingData.length" style="width:100%;border-collapse:collapse;">
                            <thead>
                                <tr>
                                    <th *ngFor="let col of scrappingColumns" style="border:1px solid #ddd;padding:5px;text-align:left;">{{ col}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of scrappingData">
                                    <td *ngFor="let col of scrappingColumns" style="border:1px solid #ddd;padding:5px;">{{ row[col] }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="!scrappingData.length" style="padding:10px">No data</div>
                    </div>
                    <div *ngIf="scrappingResultSwitch == 'terminal'" style="margin-top: 15px; height:180px; background:black; color:#00ff00; padding:10px; font-family:monospace; overflow:auto;">
                        {{ terminalOutput }} 
                    </div>
                </div>
                
            </div>
            
        </div>
    </div>
</div>
<div *ngIf="['delete_object', 'import_object'].includes(action)" class="modal-dialog modal-xl modal-content" style="padding: 10px;">
    <div class="modal-header">
        <div><h2 class="modal-title" >Caution !!!</h2></div>
    </div>
    <div class="modal-body">
        <div fxLayout="row" fxLayout.xs="column" >
            <div class="label-style" fxFlex="40">Action</div>
            <div class="separator"></div>
            <div class="class-mat-field" fxFlex="60">
                <mat-select placeholder="Action" [formControl]="actionControl">
                    <mat-option [value]="'delete_object'">Delete {{selectedRows.length}} {{manageKeyValue?.[manageKey]?.element ?? 'Element'}}(s)</mat-option>
                    <mat-option [value]="'import_object'">Import {{selectedRows.length}} {{manageKeyValue?.[manageKey]?.element ?? 'Element'}}(s)</mat-option>
                    <mat-option *ngIf="manageKey == 'vca_module'" [value]="'build_learning_content'">Build AI Learning</mat-option>
                    
                </mat-select>
            </div>
        </div>
    </div>
    <hr>
    <div class="modal-footer" style="margin-top: 5px;">
        <button type="button" class="button-secondary-small left-side" (click)="onClose()">Close</button>
        <button type="button" class="button-validate-small" (click)="verifyAndUpload()">Continue</button>
    </div>
</div>
